import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ReturnUrlService {
  private returnUrl: string | null = null;

  set(url: string) {
    this.returnUrl = url;
  }

  get(): string | null {
    return this.returnUrl;
  }

  clear() {
    this.returnUrl = null;
  }
}
